// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 400px;
}

.toast-item {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
  min-width: 300px;
  border-left: 4px solid;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.toast-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.toast-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-title {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
}

.toast-close {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.5);
  transition: color 0.2s;
}

.toast-close:hover {
  color: rgba(0, 0, 0, 0.8);
}

.toast-body {
  padding: 8px 16px 12px;
  font-size: 13px;
  color: #374151;
  line-height: 1.5;
}

/* Toast Types */
.toast-success {
  border-left-color: #10b981;
}

.toast-success .toast-icon {
  color: #10b981;
}

.toast-success .toast-title {
  color: #065f46;
}

.toast-error {
  border-left-color: #ef4444;
}

.toast-error .toast-icon {
  color: #ef4444;
}

.toast-error .toast-title {
  color: #991b1b;
}

.toast-warning {
  border-left-color: #f59e0b;
}

.toast-warning .toast-icon {
  color: #f59e0b;
}

.toast-warning .toast-title {
  color: #92400e;
}

.toast-info {
  border-left-color: #3b82f6;
}

.toast-info .toast-icon {
  color: #3b82f6;
}

.toast-info .toast-title {
  color: #1e40af;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./packages/ng-shared-ui/src/lib/organisms/toast-container/toast-container.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE;IACE,4BAAA;IACA,UAAA;EACF;EACA;IACE,wBAAA;IACA,UAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,OAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA,gBAAA;AACA;EACE,0BAAA;AAAF;;AAEA;EACE,cAAA;AACF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,cAAA;AAIF;;AADA;EACE,0BAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAHA;EACE,0BAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,cAAA;AAQF;AACA,gzIAAgzI","sourcesContent":[".toast-container {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  z-index: 9999;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  max-width: 400px;\r\n}\r\n\r\n.toast-item {\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  overflow: hidden;\r\n  animation: slideIn 0.3s ease-out;\r\n  min-width: 300px;\r\n  border-left: 4px solid;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    transform: translateX(400px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.toast-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 16px 8px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.toast-icon {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.toast-title {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.toast-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: rgba(0, 0, 0, 0.5);\r\n  transition: color 0.2s;\r\n}\r\n\r\n.toast-close:hover {\r\n  color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.toast-body {\r\n  padding: 8px 16px 12px;\r\n  font-size: 13px;\r\n  color: #374151;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Toast Types */\r\n.toast-success {\r\n  border-left-color: #10b981;\r\n}\r\n.toast-success .toast-icon {\r\n  color: #10b981;\r\n}\r\n.toast-success .toast-title {\r\n  color: #065f46;\r\n}\r\n\r\n.toast-error {\r\n  border-left-color: #ef4444;\r\n}\r\n.toast-error .toast-icon {\r\n  color: #ef4444;\r\n}\r\n.toast-error .toast-title {\r\n  color: #991b1b;\r\n}\r\n\r\n.toast-warning {\r\n  border-left-color: #f59e0b;\r\n}\r\n.toast-warning .toast-icon {\r\n  color: #f59e0b;\r\n}\r\n.toast-warning .toast-title {\r\n  color: #92400e;\r\n}\r\n\r\n.toast-info {\r\n  border-left-color: #3b82f6;\r\n}\r\n.toast-info .toast-icon {\r\n  color: #3b82f6;\r\n}\r\n.toast-info .toast-title {\r\n  color: #1e40af;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
